import { render, staticRenderFns } from "./AddPurchase.vue?vue&type=template&id=c2fb2e92&"
import script from "./AddPurchase.vue?vue&type=script&lang=js&"
export * from "./AddPurchase.vue?vue&type=script&lang=js&"
import style0 from "./AddPurchase.vue?vue&type=style&index=0&id=c2fb2e92&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports